module.exports = __webpack_public_path__ + "static/img/xqs_qrcode.112bf94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqs_qrcode.jpg
// module id = 7VKR
// module chunks = 21